module.exports = __webpack_public_path__ + "static/date_pc_dark-b615d2302774efe15455aa3976f555e0.svg";